<template>
  <div class="partnership-page">
    <div class="top-nav">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>代理合营</h1>
      <div class="placeholder"></div>
    </div>

    <div class="gallery">
      <figure
        v-for="(item, index) in posters"
        :key="item.src"
        :class="['poster', item.wide ? 'is-wide' : 'is-tall']"
        @click="previewIndex = index"
      >
        <img :src="item.src" :alt="item.alt">
      </figure>
    </div>

    <div v-if="previewIndex !== null" class="preview" @click="previewIndex = null">
      <img :src="posters[previewIndex].src" :alt="posters[previewIndex].alt" @click.stop>
      <button type="button" class="preview-close" @click="previewIndex = null">关闭</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agentPartnership',
  data() {
    return {
      previewIndex: null,
      posters: [
        { src: '/static/image/1/01-contact.jpg', alt: '招商负责人联系方式', wide: true },
        { src: '/static/image/1/02-rebate.jpg', alt: '提成返点与合营扩展计划', wide: false },
        { src: '/static/image/1/03-commission.jpg', alt: '合营佣金计划', wide: false },
        { src: '/static/image/1/04-headcount.jpg', alt: '合营人头费奖励', wide: false },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.partnership-page {
  min-height: 100vh;
  padding-bottom: 88px;
  background:
    radial-gradient(circle at top, rgba(255, 236, 196, 0.55), transparent 42%),
    linear-gradient(180deg, #fff8ee 0%, #f4eadc 100%);
}

.top-nav {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  color: #4c2a10;
  background: linear-gradient(135deg, #f5d98e 0%, #dca84f 52%, #a86128 100%);
  box-shadow: 0 6px 16px rgba(122, 72, 24, 0.18);
}

.top-nav h1 {
  margin: 0;
  color: #4c2a10;
  font-size: 17px;
  font-weight: 800;
}

.back,
.placeholder {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back {
  cursor: pointer;
}

.back i {
  color: #4c2a10;
  font-size: 20px;
}

.gallery {
  display: grid;
  gap: 12px;
  padding: 14px 12px 24px;
}

.poster {
  margin: 0;
  overflow: hidden;
  background: #2a0d0d;
  border: 1px solid rgba(168, 97, 40, 0.18);
  border-radius: 16px;
  box-shadow: 0 10px 22px rgba(92, 50, 18, 0.12);
}

.poster img {
  display: block;
  width: 100%;
  height: auto;
  vertical-align: top;
}

.preview {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 12px 28px;
  background: rgba(12, 8, 5, 0.88);
}

.preview img {
  max-width: 100%;
  max-height: calc(100vh - 92px);
  object-fit: contain;
  border-radius: 12px;
}

.preview-close {
  margin-top: 14px;
  padding: 8px 18px;
  color: #4c2a10;
  font-size: 13px;
  font-weight: 700;
  background: linear-gradient(135deg, #f5d98e, #dca84f);
  border: 0;
  border-radius: 999px;
}
</style>



// WEBPACK FOOTER //
// src/components/agentPartnership.vue